// angular
// 	.module("HeroPRO")
// 	.service("hpLoggerService", hpLoggerService);

import _ from 'lodash';
import StackTraceGPS from 'stacktrace-gps';
import ErrorStackParser from 'error-stack-parser';

/* @ngInject */
export default function hpLoggerService(HPConfig, HPLogging, $injector, $log) {
    let $http,
        FundingRequestInfo,
        $location,
        $state,
        $window,
        $q,
        timeDelay = 60000,
        maxCacheSize = 100,
        cachedFrameworkErrors = [],
        cachedLogMessages = [],
        throttleSubmitFramework = _.throttle(submitFrameworkErrors, timeDelay),
        throttleSubmitMessages = _.throttle(submitPageErrors, timeDelay);

    const gps = new StackTraceGPS();

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function submitFrameworkErrors() {
        const data = {
            LogItems: cachedFrameworkErrors,
        };

        $http = $http || $injector.get('$http');
        const _url = `${HPConfig.heroProApi}Logging/Add`;

        $http.post(_url, data);

        // Clear cache
        cachedFrameworkErrors = [];
    }

    function submitPageErrors() {
        const data = {
            LogItems: cachedLogMessages,
        };

        $http = $http || $injector.get('$http');
        const _url = `${HPConfig.heroProApi}Logging/Add`;

        $http.post(_url, data);

        // Clear cache
        cachedLogMessages = [];
    }

    function logMessage(logLevel, message, controllerName, methodName, uiState) {
        $location = $location || $injector.get('$location');
        $state = $state || $injector.get('$state');
        $window = $window || $injector.get('$window');

        const parameterPayload = {
            DateLogged: new Date(),
            Exception: (message.stack !== undefined && message.stack !== null) ? message.stack.toString() : 'No Exception Text',
            Route: $location.path(),
            UserAgent: $window.navigator.userAgent,
        };

        const methodParams = {};

        methodParams.Name = `${controllerName}::${methodName}`;
        methodParams.Params = uiState ? uiState : null;

        // (ajt 8/8/2016) - Only load state for app-detail route
        if ($state.includes('app-detail')) {
            // (ajt 8/8/2016) - Inject or use FRInformationFactory, Location service, or ui-router State service
            FundingRequestInfo = FundingRequestInfo || $injector.get('FRInformationFactory');

            const stateData = FundingRequestInfo.getStateMachineData();
            const appInfo = FundingRequestInfo.getAppInfo();

            parameterPayload.StateMachine = Object.keys(stateData).length !== 0 ? stateData : 'No State Information';
            parameterPayload.ApplicationInfo = Object.keys(appInfo).length !== 0 ? appInfo : 'No Application Information';

            // (ajt 8/8/2016) - Extend existing UI logging params with Application & State data
            _.extend(methodParams.Params, parameterPayload);
        }

        const logItem = {
            SourceApplicationName: 'RA.Web.HEROPro',
            Message: message.toString(),
            LogLevel: logLevel, // HPLogging.LogLevel.Error,
            MethodParameters: methodParams,
        };

        cachedLogMessages.push(logItem);

        if (cachedLogMessages.length > maxCacheSize) {
            submitPageErrors();
        } else {
            throttleSubmitMessages();
        }
    }

    function _generateSourceMapStackTraceErrors(messageStack) {

        $q = $q || $injector.get("$q");

        return $q((resolve, reject) => {
            let stackFrames = ErrorStackParser.parse({ stack: messageStack });
            let newFrames = new Array(stackFrames.length);
            let frameResolved = 0;
            stackFrames.forEach((stackFrame, i) => {
                gps.pinpoint(stackFrame)
                    .then(newFrame => {
                        newFrames[i] = newFrame;
                        frameResolved++;

                        if (frameResolved === stackFrames.length) {
                            let newFrameStrings = newFrames.map(frame => frame.toString())
                            resolve(newFrameStrings.join("\n"));
                        }
                    }, () => {
                        reject(arguments);
                    });
            });
        });

    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    // Method used in exceptionHandler wrapper to cache and log errors from the framework.
    this.frameworkError = function createFrameworkError(message) {
        $location = $location || $injector.get('$location');
        $state = $state || $injector.get('$state');
        $window = $window || $injector.get('$window');

        // (ajt - 5/5/2016) This step allows error to be logged to console. Remove if errors should be 'swallowed' by the service.
        $log.error(message);

        if (!message.stack) {
            return;
        }

        _generateSourceMapStackTraceErrors(message.stack)
            .then(sourceMapsStackTrace => {

                const parameterPayload = {
                    DateLogged: new Date(),
                    StackTrace: sourceMapsStackTrace,
                    Exception: message.stack.toString(),
                    Route: $location.path(),
                    UserAgent: $window.navigator.userAgent
                };

                // (ajt 8/8/2016) - Only load state for app-detail route
                if ($state.includes('app-detail')) {
                    // (ajt 8/8/2016) - Inject or use FRInformationFactory, Location service, or ui-router State service
                    FundingRequestInfo = FundingRequestInfo || $injector.get('FRInformationFactory');

                    const stateData = FundingRequestInfo.getStateMachineData();
                    const appInfo = FundingRequestInfo.getAppInfo();

                    parameterPayload.StateMachine = Object.keys(stateData).length !== 0 ? stateData : 'No State Information';
                    parameterPayload.ApplicationInfo = Object.keys(appInfo).length !== 0 ? appInfo : 'No Application Information';
                }

                const methodParams = {};

                methodParams.Name = 'ExceptionHandler';
                methodParams.Params = parameterPayload;

                const logItem = {
                    SourceApplicationName: 'RA.Web.HEROPro',
                    Message: message.toString(),
                    StackTrace: sourceMapsStackTrace,
                    LogLevel: HPLogging.LogLevel.Error,
                    MethodParameters: methodParams
                };

                cachedFrameworkErrors.push(logItem);

                if (cachedFrameworkErrors.length > maxCacheSize) {
                    submitFrameworkErrors();
                } else {
                    throttleSubmitFramework();
                }
            })
            .catch(err => console.log(err));

    };

    // Method used to log errors generated within a page.
    this.error = function (message, controllerName, methodName, uiState) {
        logMessage(HPLogging.LogLevel.Error, message, controllerName, methodName, uiState);
    };

    // Method used to log informational messages generated in a page controller.
    this.info = function (message, controllerName, methodName, uiState) {
        logMessage(HPLogging.LogLevel.Info, message, controllerName, methodName, uiState);
    };

}




// WEBPACK FOOTER //
// ./src/app/common/logging/loggerService.js